module.exports = __webpack_public_path__ + "img/Slide006.6c93e269.jpg";